export default __webpack_public_path__ + "static/media/Psyche_Inspired_Artwork_1024x1024.04852407.png";